
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 28.5 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.5 25c.3 1.5.7 3 1.4 4.4 2.4 4.8 8.6 2.4 7.1-2.5-.5-1.4-1.1-2.8-2-4.1-2.1.7-4.3 1.5-6.5 2.2zm-2.9-7.6c.8 2.1 1.3 3.5 2.1 5.2 3.2-1 3.6-1.2 6.3-2.1.5-2.3 1-4.6 1.8-6.9.7-3.4.1-6.9-1.8-9.8-.5-1-1.3-1.8-2.1-2.5C7.3.8 4.1-.8 1.3 4.7.3 6.7-.1 9 .1 11.3c.1 2.1.7 4.2 1.5 6.1zM23 28.7c.6-1.4 1-2.9 1.3-4.4l-6.5-2c-.8 1.3-1.4 2.7-1.9 4.1-1.5 4.9 4.8 7.2 7.1 2.3zm-4.3-8.8c2.8.8 3.2 1 6.4 2 .8-1.7 1.3-3.1 2-5.2.8-1.9 1.3-4 1.4-6.1.1-2.3-.3-4.6-1.4-6.6C24.2-1.5 21 .2 20.4.6c-.8.7-1.5 1.6-2 2.6-1.8 2.9-2.4 6.5-1.6 9.8.7 2.3 1.4 4.6 1.9 6.9z"}})])
          )
        }
      }
    